import { render, staticRenderFns } from "./ticket-sale.vue?vue&type=template&id=ebfb98e6&scoped=true"
import script from "./ticket-sale.vue?vue&type=script&lang=js"
export * from "./ticket-sale.vue?vue&type=script&lang=js"
import style0 from "./ticket-sale.vue?vue&type=style&index=0&id=ebfb98e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfb98e6",
  null
  
)

export default component.exports